import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'assess-layout-container',
  templateUrl: './layout-container.component.html',
  styleUrls: ['./layout-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutContainerComponent {}
